const STORAGE_PREFIX = 'teo_popup_';

function sessionStore(): Storage | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function isExitIntentDismissed(slug: string): boolean {
  const storage = sessionStore();
  if (!storage) return false;
  return storage.getItem(`${STORAGE_PREFIX}exit:${slug}`) === '1';
}

export function markExitIntentDismissed(slug: string): void {
  const storage = sessionStore();
  if (!storage) return;
  storage.setItem(`${STORAGE_PREFIX}exit:${slug}`, '1');
}

/**
 * Context popup suppress for the **current visit** to this pathname.
 * Cleared when the user navigates away and returns (see
 * `clearContextPopupDismissed` / page-enter schedule).
 */
export function isContextPopupDismissed(
  slug: string,
  pathname: string,
): boolean {
  const storage = sessionStore();
  if (!storage) return false;
  return (
    storage.getItem(`${STORAGE_PREFIX}context:${slug}:${pathname}`) === '1'
  );
}

export function markContextPopupDismissed(
  slug: string,
  pathname: string,
): void {
  const storage = sessionStore();
  if (!storage) return;
  storage.setItem(`${STORAGE_PREFIX}context:${slug}:${pathname}`, '1');
}

/** Allow the context popup again on a fresh visit to this pathname. */
export function clearContextPopupDismissed(
  slug: string,
  pathname: string,
): void {
  const storage = sessionStore();
  if (!storage) return;
  storage.removeItem(`${STORAGE_PREFIX}context:${slug}:${pathname}`);
}

/** Clears popup dismiss flags (playground / support). Optional slug filter. */
export function clearPopupSessionState(slug?: string): string[] {
  const storage = sessionStore();
  if (!storage) return [];

  const keys: string[] = [];
  for (let i = 0; i < storage.length; i++) {
    const key = storage.key(i);
    if (key?.startsWith(STORAGE_PREFIX)) {
      if (!slug || key.includes(slug)) keys.push(key);
    }
  }
  for (const key of keys) {
    storage.removeItem(key);
  }
  return keys;
}
